/* eslint-disable no-unused-vars */
import { useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { IconButton, Tooltip } from "@material-ui/core";
import Table from "../../../components/Table/Table";
import { Header } from "../../../components";
import {
  ApproverApprovedAndRejectedBaseColumns,
  PerformerRejectedBaseColumns,
} from "../../../utils/utils";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../../layouts/TableLayout/TableLayout";
import useTicketData from "../../../hooks/useTicketData";
import useTicketFilters from "../../../utils/ticketFilters";
import ActionButtons from "../../../components/TableComponents/ActionButtons/ActionButtons";
import { ROUTES } from "../../../constants";
import useTicketExport from "../../../hooks/useTicketExport";
import PhysicalDocumentToggle from "../../../components/TableComponents/PhysicalDocumentToggle/PhysicalDocumentToggle";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";

function Rejected() {
  const history = useHistory();

  // Custom hooks
  const {
    searchQuery,
    allRows: filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTicketData("APPROVER_REJECTED", true);

  const handleActionClick = useCallback((action, rowData) => {
    if (action === "Resubmit") {
      // Handle the action for resubmitting the ticket
      history.push(
        ROUTES.GOTOQUESTIONNAIRE(rowData.id, rowData.ticketNumber, "resubmit")
      );
    }
  }, []);

  // Column configuration
  const columns = useMemo(() => {
    const updatedColumns = [...ApproverApprovedAndRejectedBaseColumns];

    updatedColumns[0] = {
      width: 180,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <TicketButton
          ticketNumber={rowData.ticketNumber}
          ticketId={rowData.id}
        />
      ),
    };

    updatedColumns[3] = {
      width: 260,
      title: "Physical Document Received",
      field: "physicalDocumentReceived",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => {
        const value = rowData.physicalDocumentReceived;

        return <PhysicalDocumentToggle checked={value} />;
      },
    };

    updatedColumns[4] = {
      width: 220,
      title: "Document",
      field: "document",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <div style={{ display: "flex", alignItems: "center", gap: "0.1rem" }}>
          <span style={{ marginRight: "0.1rem" }}>{rowData.document}</span>

          <Tooltip title="Download">
            <IconButton
              size="small"
              color="primary"
              onClick={() => console.log(`Downloading ${rowData.document}`)}
            >
              <GetAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="View">
            <IconButton
              size="small"
              color="primary"
              onClick={() => console.log(`Viewing ${rowData.document}`)}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    };

    return updatedColumns;
  }, []);

  const { handleExport, isExporting } = useTicketExport(
    "APPROVER_REJECTED",
    columns
  );

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}
      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </TableLayout>
  );
}

export default Rejected;
